import {
  Button,
  ButtonGroup,
  ModalBody,
  ModalFooter,
  Typography,
} from '@one-thd/sui-atomic-components';
import React, { useState, JSX } from 'react';
import { TQBRenderFlag } from '../../../../models/purchase-history/quick-books-export';

interface IStepTemplate {
  icon: JSX.Element;
  title: string;
  description: string;
}

const Step1Props: IStepTemplate = {
  icon: (
    <img
      src="https://assets.thdstatic.com/images/v1/BackupFiles.svg"
      alt="Backup Files"
      width="140px"
      height="140px"
    />
  ),
  title: 'Back Up Data Before Importing',
  description: 'Create a backup of your company data in QuickBooks.',
};

const Step2Props: IStepTemplate = {
  icon: (
    <img
      src="https://assets.thdstatic.com/images/v1/ImportFiles.svg"
      alt="Import Files"
      width="260px"
      height="130px"
    />
  ),
  title: 'Open the Imported File',
  description:
    'Open QuickBooks. Select File > Utilities > Import > IIF Files from the File dropdown menu in QuickBooks to start the process.',
};

const Step3Props: IStepTemplate = {
  icon: (
    <img
      src="https://assets.thdstatic.com/images/v1/Find.svg"
      alt="Find"
      width="140px"
      height="150px"
    />
  ),
  title: 'Back Up Data Before Importing',
  description:
    'Look for the newly imported file in your Downloads folder and select "Open".',
};

const Step4Props: IStepTemplate = {
  icon: (
    <img
      src="https://assets.thdstatic.com/images/v1/UploadComplete.svg"
      alt="Upload Complete"
      width="130px"
      height="120px"
    />
  ),
  title: `You're all Set!`,
  description: `You've successfully imported your IIF file. You can view your newly imported file in your Credit Cards Activities.`,
};

const StepTemplate = (props: IStepTemplate) => {
  const { icon, title, description } = props;
  return (
    <div>
      {icon}
      <div className="sui-py-1">
        <Typography align="center" variant="body-lg" weight="bold">
          {title}
        </Typography>
      </div>
      <div className="sui-py-1">
        <Typography align="center" variant="body-base">
          {description}
        </Typography>
      </div>
    </div>
  );
};

const QBWalkthroughStepper: { [key: number]: JSX.Element } = {
  1: <StepTemplate {...Step1Props} />,
  2: <StepTemplate {...Step2Props} />,
  3: <StepTemplate {...Step3Props} />,
  4: <StepTemplate {...Step4Props} />,
};

const handleNextClick = (
  currentStep: number,
  setCurrentStep: (value: number) => void,
) => {
  if (currentStep === 4) {
    setCurrentStep(1);
  } else {
    setCurrentStep(currentStep + 1);
  }
};

const QBDesktopExportWalkthrough = (props: {
  setQBRenderFlag: (value: TQBRenderFlag) => void;
}) => {
  const { setQBRenderFlag } = props;
  const [currentStep, setCurrentStep] = useState<number>(1);

  return (
    <>
      <ModalBody>{QBWalkthroughStepper[currentStep]}</ModalBody>
      <ModalFooter position="end">
        <ButtonGroup>
          <Button
            onClick={() => {
              setQBRenderFlag(undefined);
            }}
          >
            Go Back
          </Button>
          <Button onClick={() => handleNextClick(currentStep, setCurrentStep)}>
            Next
          </Button>
        </ButtonGroup>
      </ModalFooter>
    </>
  );
};

export default QBDesktopExportWalkthrough;
